import { render, staticRenderFns } from "./PorletLabel.vue?vue&type=template&id=5e968620"
import script from "./PorletLabel.vue?vue&type=script&lang=js"
export * from "./PorletLabel.vue?vue&type=script&lang=js"
import style0 from "./PorletLabel.vue?vue&type=style&index=0&id=5e968620&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports